import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { FaTags, FaPercentage, FaDollarSign } from 'react-icons/fa';
import './DiscountType.scss';

interface DiscountTypeProps {
  discountType: string;
  setDiscountType: (type: string) => void;
  discountAmount: number | null;
  setDiscountAmount: (amount: number | null) => void;
  discountPercentage: number | null;
  setDiscountPercentage: (percentage: number | null) => void;
  amountError: string;
}

const DiscountType: React.FC<DiscountTypeProps> = ({
  discountType,
  setDiscountType,
  discountAmount,
  setDiscountAmount,
  discountPercentage,
  setDiscountPercentage,
  amountError
}) => {
  return (
    <div className="form-section discount-type-section">
      <div className="section-title">
        <FaTags className="section-icon" />
        Tipo de descuento
      </div>
      <div className="type-selection">
        <div
          className={`type-option ${discountType === 'Percentage' ? 'active' : ''}`}
          onClick={() => { setDiscountType('Percentage'); setDiscountAmount(null); }}
        >
          <div className="type-header">
            <div className="type-icon"><FaPercentage /></div>
            <div className="type-title">Porcentaje</div>
          </div>
          <div className="type-description">Basado en porcentaje del total</div>
        </div>
        <div
          className={`type-option ${discountType === 'Amount' ? 'active' : ''}`}
          onClick={() => { setDiscountType('Amount'); setDiscountPercentage(null); }}
        >
          <div className="type-header">
            <div className="type-icon"><FaDollarSign /></div>
            <div className="type-title">Monto fijo</div>
          </div>
          <div className="type-description">Descuento de cantidad fija en pesos</div>
        </div>
      </div>
      {discountType && (
        <div className="amount-input-container">
          {discountType === 'Percentage' ? (
            <InputGroup>
              <Form.Control
                type="number"
                min={1}
                max={100}
                value={discountPercentage !== null ? discountPercentage : ''}
                onChange={(e) => setDiscountPercentage(Math.max(1, Math.min(100, Number(e.target.value))))}
                required
                placeholder="Porcentaje de descuento (Ej: 15)"
              />
              <InputGroup.Text className="signo">%</InputGroup.Text>
            </InputGroup>
          ) : (
            <InputGroup>
              <InputGroup.Text className="signo">$</InputGroup.Text>
              <Form.Control
                type="number"
                min={0}
                value={discountAmount !== null ? discountAmount : ''}
                onChange={(e) => setDiscountAmount(Math.max(0, Number(e.target.value)))}
                required
                placeholder="Monto de descuento (Ej: 1000)"
                isInvalid={!!amountError}
              />
            </InputGroup>
          )}
          {amountError && <div className="error-message">{amountError}</div>}
        </div>
      )}
    </div>
  );
};

export default DiscountType;
